import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectGanttChartStore } from 'Store/ProjectGanttChart'

const ViewModel = () => {
  const { id } = useParams()
  const { project, tasks, getOne, getTasks } = useProjectGanttChartStore()

  const fetchProject = async (projectId: string) => {
    try {
      await getOne(projectId)
    } catch (err: any) {
      console.log(err)
    }
  }

  const fetchGanttChart = async (projectId: string) => {
    try {
      await getTasks(projectId)
    } catch (err: any) {
      console.log(err)
    }
  }

  useEffect(() => {
    const action = async () => {
      if (id) {
        await fetchProject(id)
        await fetchGanttChart(id)
      }
    }

    action()
    // eslint-disable-next-line @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps
  }, [id])

  return {
    project,
    tasks,
  }
}

export default ViewModel
